import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../../Messages";
import {Tooltip, TooltipStyle} from "../../../../ui/Tooltip";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {UserPreferencesStore, WalletStore} from "../../../../State";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {Direction} from "../../../../../stem-core/src/ui/Constants";
import {Money} from "../../../../../client/state/misc/Money";


class WalletTooltipStyle extends TooltipStyle {
    @styleRuleInherit
    tooltip = {
        background: this.themeProps.WALLET_TOOLTIP_BACKGROUND,
        border: () => ".05rem solid " + this.themeProps.WALLET_TOOLTIP_BORDER,
        boxShadow: this.themeProps.WALLET_TOOLTIP_SHADOW,
        fontSize: 12,
        padding: 12,
        width: 264,
        ">*": {
            whiteSpace: "initial",
        },
    };

    before = {
        content: "\" \"",
        display: "block",
        width: 12,
        height: 12,
        position: "absolute",
        borderRadius: 3.6,
        background: "inherit",
        zIndex: -1,
    };

    @styleRuleInherit
    renderBelow = {
        transform: "translateX(calc(50% + 46px))",
        "::before": Object.assign({}, this.before, {
            transform: "translateX(-50%) rotate(-45deg) skew(10deg,10deg)",
            top: -5,
            left: "calc(50% - 46px)",
        }),
    };

    @styleRule
    message = {
        color: this.themeProps.WALLET_TOOLTIP_TEXT_1,
    };
}

@registerStyle(WalletTooltipStyle)
export class AutoReloadTooltip extends Tooltip {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            parentTarget: true,
            appearsOnHover: true,
            direction: Direction.DOWN,
            distance: 6,
        };
    }

    render() {
        const {autoTopUpAmount, autoTopUpThreshold} = UserPreferencesStore.getPreferences();
        const currency = WalletStore.getWallet().getCurrency();
        const {styleSheet} = this;

        return <div className={styleSheet.message}>
            {Messages.autoReloadWallet(new Money(autoTopUpAmount, currency), new Money(autoTopUpThreshold, currency))}
        </div>;
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(UserPreferencesStore, () => this.redraw());
        this.attachChangeListener(WalletStore, () => this.redraw());
    }
}
